import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function AsanaConnectForm({ onSubmit, guideMode }) {
  const [showToken, setShowToken] = useState(false);
  const handleClickShowToken = () => setShowToken(!showToken);
  const handleMouseDownShowToken = () => setShowToken(!showToken);
  const formInitialValues = {
    token: "",
  };
  const formCheckoutSchema = yup.object().shape({
    token: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="token"
                label="Personal Access Token"
                value={values.token}
                type={showToken ? "text" : "password"}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.token && !!errors.token}
                helperText={touched.token && errors.token}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowToken}
                        onMouseDown={handleMouseDownShowToken}
                      >
                        {showToken ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box width={700} display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
